import { IconName } from "@fortawesome/fontawesome-svg-core";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RectangleIcon } from "../../../common/assets";
import { Colors } from "../../../styles/colors";

export const AssessmentShapeChecker = ({ ...props }: AssessmentShapeProps): JSX.Element => {
    if (props.success) {
        return <FontAwesomeIcon icon={solid("circle-check")} size="6x" color={Colors.successGreen} />;
    }

    if (props.loading) {
        return <FontAwesomeIcon icon={faSpinner} size="6x" color={Colors.darkBlue} className="fa-spin" />;
    }

    return getShape(props.shape);
};

const getShape = (shape: IconName): JSX.Element => {
    switch (shape) {
        case "circle":
            return <FontAwesomeIcon icon={solid("circle")} size="8x" color={Colors.darkBlue} />;
        case "rectangle":
            return <RectangleIcon />;
        default:
            return <FontAwesomeIcon icon={solid("circle-exclamation")} size="8x" color={Colors.darkBlue} />;
    }
};

interface AssessmentShapeProps {
    shape: "circle" | "rectangle";
    success?: boolean;
    loading?: boolean;
}
